import { createRoot } from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/js/bootstrap.bundle.min'; // 包含Popper
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './i18n.js';
import React from 'react';
import 'animate.css'; // 全局引入
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'linearicons';

createRoot(document.getElementById('root')).render(<App />);
